'use strict';

import '../css/style.scss';

$(window).on('load resize', function() {
  var winsize = window.innerWidth;
  if (winsize < 640) {
    $('img').each(function() {
      var src = $(this).attr('src');
      var newsrc = src.replace('/pc/', '/sp/');
      $(this).attr('src', newsrc);
    });
  } else {
    $('img').each(function() {
      var src = $(this).attr('src');
      var newsrc = src.replace('/sp/', '/pc/');
      $(this).attr('src', newsrc);
    });
  }
});

fetch('./other.json').then((response) => {
  if (response.ok) {
    return response.json();
  } else {
    throw new Error();
  }
}).then((json) => {
  for(let i = 0; i < json.length; i++){
    const _json = json[i];
    console.log(_json)
    let list = document.createElement('li');

    let
      link = document.createElement('a'),
      thumb = document.createElement('img'),
      other_txt = document.createElement('p'),
      number = document.createElement('span'),
      title = document.createElement('span'),
      check = document.createElement('img')

    thumb.setAttribute('src', _json.thumb);
    thumb.classList.add('thumb-other');
    other_txt.classList.add('other-txt');
    number.classList.add('number');
    number.insertAdjacentHTML('afterbegin', _json.number);
    title.classList.add('title');
    title.insertAdjacentHTML('afterbegin', _json.title);

    list.appendChild(link);
    link.setAttribute('href', 'https://tachikichi.jp');
    link.appendChild(thumb);
    link.appendChild(other_txt);
    other_txt.appendChild(number);
    other_txt.appendChild(title);

    check.setAttribute('src', './images/pc/btn-check-b.jpg');
    check.classList.add('check');
    link.appendChild(check)

    document.getElementById('list-other').appendChild(list);
  }

  console.log(json.length)
}).catch((error) => console.log(error));
